import React from 'react';
import PropTypes from 'prop-types';
import { Col, KeyValue, NoValue, Row } from '@folio/stripes-components';
import { getCustomFieldValue } from '../../../../utils/utils';

function TextFieldView({ fieldValues, locale, data }) {
  const { name, label, schema } = fieldValues;
  const fieldLabel = label.find((field) => field.locale === locale)?.value;
  const fieldValue =
    schema === 'default' ? data[name] : getCustomFieldValue(name, data);

  return (
    <Row>
      <Col xs={12}>
        <KeyValue label={fieldLabel} value={fieldValue || <NoValue />} />
      </Col>
    </Row>
  );
}

TextFieldView.propTypes = {
  fieldValues: PropTypes.object,
  locale: PropTypes.string,
  data: PropTypes.object,
};

export default TextFieldView;
